import { IconProps } from './index';

export const ColumnVisibilityIcon = ({ className = '', color }: IconProps) => {
  return (
    <svg
      className={className}
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.7314 0.00585938C13.1092 0.126322 15 2.09234 15 4.5V8.7627C14.6161 8.18501 14.1021 7.70192 13.5 7.35352V4.5C13.5 2.89356 12.2374 1.58126 10.6504 1.50293V6.79004C10.1148 6.86136 9.60922 7.02701 9.15039 7.26953V1.5H5.84961V13.5H7.35352C7.70205 14.1023 8.18569 14.616 8.76367 15H4.5C2.09234 15 0.126322 13.1092 0.00585938 10.7314L0 10.5V4.5C9.66399e-08 2.01472 2.01472 9.66384e-08 4.5 0H10.5L10.7314 0.00585938ZM4.34961 1.50293C2.76261 1.58126 1.5 2.89356 1.5 4.5V10.5C1.5 12.1064 2.76263 13.4177 4.34961 13.4961V1.50293Z'
        fill={color ?? 'currentColor'}
      />
      <mask
        id='mask0_7993_25903'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='15'
        height='15'
      >
        <path
          d='M0 4.5C0 2.01472 2.01472 0 4.5 0H10.5C12.9853 0 15 2.01472 15 4.5V10.5C15 12.9853 12.9853 15 10.5 15H4.5C2.01472 15 0 12.9853 0 10.5V4.5Z'
          fill='black'
        />
      </mask>
      <g mask='url(#mask0_7993_25903)'>
        <rect opacity='0.18' width='5.1' height='15' fill={color ?? 'currentColor'} />
      </g>
      <path d='M13.0503 9.45001L9.45029 13.05' stroke={color ?? 'currentColor'} strokeWidth='1.5' />
      <path d='M9.4502 9.45001L13.0502 13.05' stroke={color ?? 'currentColor'} strokeWidth='1.5' />
    </svg>
  );
};
